document.addEventListener('DOMContentLoaded', () => {
    // eslint-disable-next-line no-unused-vars, no-undef
    const pluginInstance = new ValidateAccessCode({
        input: document.getElementById('accessCode'),
        group: document.querySelector('.form-group'),
        button: document.querySelector('.js-redeem-access-code-button'),
        container: document.querySelector('.redeem-page-container'),
    });
});
